export const GET_REPORTED_TICKETS_REQUEST = "GET_REPORTED_TICKETS_REQUEST";
export const GET_REPORTED_TICKETS_SUCCESS = "GET_REPORTED_TICKETS_SUCCESS";
export const GET_REPORTED_TICKETS_FAILURE = "GET_REPORTED_TICKETS_FAILURE";

export const CREATE_REPORT_TICKET_REQUEST = "CREATE_REPORT_TICKET_REQUEST";
export const CREATE_REPORT_TICKET_SUCCESS = "CREATE_REPORT_TICKET_SUCCESS";
export const CREATE_REPORT_TICKET_FAILURE = "CREATE_REPORT_TICKET_FAILURE";

export const ADD_ATTACHMENTS_REQUEST = "ADD_ATTACHMENTS_REQUEST";
export const ADD_ATTACHMENTS_SUCCESS = "ADD_ATTACHMENTS_SUCCESS";
export const ADD_ATTACHMENTS_FAILURE = "ADD_ATTACHMENTS_FAILURE";


export const GET_REQUESTTYPES_REQUEST = "GET_REQUESTTYPES_REQUEST";
export const GET_REQUESTTYPES_SUCCESS = "GET_REQUESTTYPES_SUCCESS";
export const GET_REQUESTTYPES_FAILURE = "GET_REQUESTTYPES_FAILURE";

export const GET_TICKET_STATUS_REQUEST = "GET_TICKET_STATUS_REQUEST";
export const GET_TICKET_STATUS_SUCCESS = "GET_TICKET_STATUS_SUCCESS";
export const GET_TICKET_STATUS_FAILURE = "GET_TICKET_STATUS_FAILURE";

export const GET_TICKET_COMMENTS_REQUEST = "GET_TICKET_COMMENTS_REQUEST";
export const GET_TICKET_COMMENTS_SUCCESS = "GET_TICKET_COMMENTS_SUCCESS";
export const GET_TICKET_COMMENTS_FAILURE = "GET_TICKET_COMMENTS_FAILURE";

export const ADD_TICKET_COMMENTS_REQUEST = "ADD_TICKET_COMMENTS_REQUEST";
export const ADD_TICKET_COMMENTS_SUCCESS = "ADD_TICKET_COMMENTS_SUCCESS";
export const ADD_TICKET_COMMENTS_FAILURE = "ADD_TICKET_COMMENTS_FAILURE";

export const RE_OPEN_TICKET_REQUEST = "RE_OPEN_TICKET_REQUEST";
export const RE_OPEN_TICKET_SUCCESS = "RE_OPEN_TICKET_SUCCESS";
export const RE_OPEN_TICKET_FAILURE = "RE_OPEN_TICKET_FAILURE";

export const TICKET_HOMEPAGE_REQUEST = "TICKET_HOMEPAGE_REQUEST";
export const TICKET_HOMEPAGE_SUCCESS = "TICKET_HOMEPAGE_SUCCESS";
export const TICKET_HOMEPAGE_FAILURE = "TICKET_HOMEPAGE_FAILURE";

export const GET_USERS_BY_CLIENT_REQUEST = "GET_USERS_BY_CLIENT_REQUEST";
export const GET_USERS_BY_CLIENT_SUCCESS = "GET_USERS_BY_CLIENT_SUCCESS";
export const GET_USERS_BY_CLIENT_FAILURE = "GET_USERS_BY_CLIENT_FAILURE";


export const GET_COMPLETED_TICKETS_REQUEST = "GET_COMPLETED_TICKETS_REQUEST";
export const GET_COMPLETED_TICKETS_SUCCESS = "GET_COMPLETED_TICKETS_SUCCESS";
export const GET_COMPLETED_TICKETS_FAILURE = "GET_COMPLETED_TICKETS_FAILURE";



export const GET_CLIENT_TICKETS_STATUS_REQUEST = "GET_CLIENT_TICKETS_STATUS_REQUEST";
export const GET_CLIENT_TICKETS_STATUS_SUCCESS = "GET_CLIENT_TICKETS_STATUS_SUCCESS";
export const GET_CLIENT_TICKETS_STATUS_FAILURE = "GET_CLIENT_TICKETS_STATUS_FAILURE";

export const GET_CLIENT_TICKETS_STATUS_FOR_ACTIVE_REQUEST = "GET_CLIENT_TICKETS_STATUS_FOR_ACTIVE_REQUEST";
export const GET_CLIENT_TICKETS_STATUS_FOR_ACTIVE_SUCCESS = "GET_CLIENT_TICKETS_STATUS_FOR_ACTIVE_SUCCESS";
export const GET_CLIENT_TICKETS_STATUS_FOR_ACTIVE_FAILURE = "GET_CLIENT_TICKETS_STATUS_FOR_ACTIVE_FAILURE";



